"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = require("js-cookie");
var XSRF_TOKEN_COOKIE_KEY = 'XSRF-TOKEN';
var XSRF_TOKEN_HEADER_KEY = 'X-XSRF-TOKEN';
exports.VIZPORTAL_API_PATH = '/vizportal/api/web/v1';
/**
 * Implementation of a WebClientRequester that uses the fetch API protocols
 */
var WebClientFetchRequester = (function () {
    function WebClientFetchRequester(vizPortalWebClientApiPrefix, hostname, xsrfToken) {
        if (vizPortalWebClientApiPrefix === void 0) { vizPortalWebClientApiPrefix = "" + exports.VIZPORTAL_API_PATH; }
        if (hostname === void 0) { hostname = ''; }
        if (xsrfToken === void 0) { xsrfToken = ''; }
        this.vizPortalWebClientApiPrefix = vizPortalWebClientApiPrefix;
        this.hostname = hostname;
        this.xsrfToken = xsrfToken;
        if (typeof fetch === 'undefined' || typeof Request === 'undefined' || typeof Response === 'undefined') {
            throw new Error('The fetch API is not defined in this browser. Try adding a polyfill library like "whatwg-fetch"');
        }
        if (typeof Promise === 'undefined') {
            throw new Error('Promise is not defined in this browser. Try adding a polyfill library like "es6-promise"');
        }
    }
    WebClientFetchRequester.prototype.send = function (webClientRequest) {
        var _this = this;
        var path = "" + this.hostname + this.vizPortalWebClientApiPrefix + "/" + webClientRequest.method.name;
        var init = {
            method: 'POST',
            headers: this.getHeaders(),
            cache: 'default',
            mode: 'cors',
            credentials: 'same-origin',
            body: JSON.stringify({
                method: webClientRequest.method.name,
                params: webClientRequest.params
            })
        };
        var req = new Request(path, init);
        return fetch(req)
            .then(function (res) {
            return res
                .json()
                .then(function (response) { return ({
                response: response,
                fetchRequest: req,
                fetchResponse: res
            }); }, function (error) { return ({
                error: _this.responseToWebClientError(res, error),
                fetchRequest: req,
                fetchResponse: res
            }); });
        });
    };
    WebClientFetchRequester.prototype.responseToWebClientError = function (res, error) {
        // TODO: Replace with local error codes
        switch (res.status) {
            case 400: return { code: 400, error: error };
            default: return { code: 1, message: 'Unknown error', error: error };
        }
    };
    WebClientFetchRequester.prototype.getXsrfToken = function () {
        return WebClientFetchRequester.getXsrfToken();
    };
    WebClientFetchRequester.prototype.getHeaders = function () {
        return new Headers((_a = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            _a[XSRF_TOKEN_HEADER_KEY] = this.xsrfToken == '' ? this.getXsrfToken() : this.xsrfToken,
            _a));
        var _a;
    };
    WebClientFetchRequester.getXsrfToken = function () {
        return js_cookie_1.get(XSRF_TOKEN_COOKIE_KEY);
    };
    return WebClientFetchRequester;
}());
exports.WebClientFetchRequester = WebClientFetchRequester;
//# sourceMappingURL=WebClientFetchRequester.js.map